import { useEffect, useMemo, useState } from "react";
import { useSelectedSetDesigns } from "../../components/ui/modals/giantModal/apis/categoryAPIs";
import LongCard from "../../components/ui/cards/longCard/LongCard";
import { useGlobalContext } from "../../context/GlobalContext";

const LongCardProduct = ({ data, onDelete, modifyData }) => {
  const { cartData } = useGlobalContext();

  const { data: modalData } = useSelectedSetDesigns({
    styleNumber: data?.styleNumber,
    cartDesigns: cartData?.map((design) => design?.styleNumber),
  });

  const displayData = useMemo(() => {
    if (!modalData) return [];
    return cartData?.filter((item) =>
      modalData?.includes(item?.styleNumber)
    );
  }, [modalData, cartData]);
  

  const checkSetQualityMatch = useMemo(() => {
    const latestSetItems = cartData?.filter((item) =>
      modalData?.includes(item?.styleNumber)
    );
  
    const achaWalaData = latestSetItems?.flatMap((design) => design?.quantityData || []);
    const dusraData = data?.quantityData || [];
  
    const answerData = [...achaWalaData, ...dusraData];
  
    if (answerData.length === 0) return false;
  
    const allGoldColors = new Set(answerData?.map(item => item?.goldColor));
    const allGoldQtys = new Set(answerData?.map(item => item?.goldQty));
    const allDiaQtys = new Set(answerData?.map(item => item?.diaQty));
  
    return allGoldColors?.size === 1 && allGoldQtys?.size === 1 && allDiaQtys?.size === 1;
  }, [cartData, modalData, data.quantityData]);
  

  return (
    <>
      <LongCard
        key={data?._id}
        data={data}
        modifyData={modifyData}
        modify={false}
        displayData={displayData}
        checkSetQualityMatch={checkSetQualityMatch}
        onDelete={onDelete}
        setIcon
      />
    </>
  );
};

export default LongCardProduct;
